import { render, staticRenderFns } from "./EditarEntradaConRecinto.vue?vue&type=template&id=6976b22e"
import script from "./EditarEntradaConRecinto.vue?vue&type=script&lang=js"
export * from "./EditarEntradaConRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports